import { ReactElement } from 'react'
import { Stack, Typography } from '@mui/material'
import { useEditorViewStore } from '@editorStores'
import StoreyTypeToggleButton from '../../../../components/StoreyControls/StoreyTypeToggleButton'

const LOAD_TYPE_SWITCHES = [
  { loadType: 'point-load' as const, label: 'Punktl.' },
  { loadType: 'line-load' as const, label: 'Linienl.' },
  { loadType: 'area-load' as const, label: 'Flächenl.' },
]

const Results2SceneLoadTypeSwitches = (): ReactElement => {
  const visibleLoadTypes = useEditorViewStore(state => state.results.visibleLoadTypes)
  const setVisibleLoadType = useEditorViewStore(state => state.setResultsVisibleLoadType)

  return (
    <Stack
      direction="column"
      spacing={0.5}
      alignItems="flex-start"
      sx={{ minWidth: 0, width: '100%', py: 0.125, maxWidth: 'min-content' }}
    >
      <Typography fontSize="small">Bauteil</Typography>
      <Stack
        direction="column"
        alignItems="flex-start"
        flexWrap="wrap"
        sx={{ gap: 0.5, width: '100%', maxWidth: 160 }}
      >
        {LOAD_TYPE_SWITCHES.map(({ loadType, label }) => (
          <StoreyTypeToggleButton
            key={loadType}
            value={loadType}
            label={label}
            selected={visibleLoadTypes[loadType]}
            onToggle={() => setVisibleLoadType(loadType, !visibleLoadTypes[loadType])}
          />
        ))}
      </Stack>
    </Stack>
  )
}

export default Results2SceneLoadTypeSwitches
